// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__Pct0T","msgBox":"NotFound_msgBox__WQ0ai","errorCode":"NotFound_errorCode__uxJjn","homeBtn":"NotFound_homeBtn__nv9SW"};